import api from "app/lib/api";
import { EXCEL_CONTENT_TYPE } from "static/constants";
import endpoints from "static/endpoints";

export const getDeviceTypePatients = async () => {
  const url = endpoints.dashboard.deviceTypePatients;

  const { data, headers } = await api.get(url, {
    responseType: "blob",
  });

  const contentType = headers?.get("Content-Type");

  if (contentType !== EXCEL_CONTENT_TYPE) {
    const jsonData = JSON.parse(await data.text());
    return { ...jsonData };
  }

  const fileHeader = headers?.get("Content-Disposition");
  const filename = fileHeader?.split("filename=")[1];
  return { data, filename };
};
